import { Card } from "@/shared/components/ui/card";
import type { CollectionStatusSummary, CollectionStatusTab } from "../types/collection-types";

interface Props {
  summary: CollectionStatusSummary;
  onSelectTab: (tab: CollectionStatusTab) => void;
}

export function CollectionStatusStats({ summary, onSelectTab }: Props) {
  return (
    <div className="grid gap-3 md:grid-cols-3">
      <Card className="cursor-pointer p-4 hover:bg-muted/40" onClick={() => onSelectTab("success")}>
        <div className="text-sm text-muted-foreground">성공한 수집 개수</div>
        <div className="mt-2 text-3xl font-semibold text-teal-600">{summary.success_count}</div>
      </Card>

      <Card className="cursor-pointer p-4 hover:bg-muted/40" onClick={() => onSelectTab("error")}>
        <div className="text-sm text-muted-foreground">실패한 수집 개수</div>
        <div className="mt-2 text-3xl font-semibold text-rose-600">{summary.error_count}</div>
      </Card>

      <Card className="cursor-pointer p-4 hover:bg-muted/40" onClick={() => onSelectTab("in_progress")}>
        <div className="text-sm text-muted-foreground">진행 중인 수집 개수</div>
        <div className="mt-2 text-3xl font-semibold text-blue-600">{summary.in_progress_count}</div>
      </Card>
    </div>
  );
}